import { Box } from "@mui/material";
import { IconArrowRight } from "@tabler/icons-react";
import CILevel from "./CILevel";

export interface CIProgressionProps {
  start?: string;
  now?: string;
  intact?: boolean;
}

const CIProgression = ({ start, now, intact }: CIProgressionProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        flexWrap: "nowrap",
        whiteSpace: "nowrap",
      }}
    >
      {start && now && start !== now ? (
        <>
          <CILevel
            level={start}
            showAsterisk={intact}
            sx={{ marginRight: 0 }}
          />
          <IconArrowRight size={16} style={{ color: "gray" }} />
          <CILevel level={now} />
        </>
      ) : now ? (
        <CILevel level={now} showAsterisk={intact} />
      ) : null}
    </Box>
  );
};

export default CIProgression;
